import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Match_PageMenu_ApiEnum } from './MatchDetailConfigApiInterface';

export enum Config_MatchAuditLog_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_MatchAuditLog_Modules_ApiEnum {
    'results' = 'results',
    'indications' = 'indications',
    'overview' = 'overview',
    'warning' = 'warning',
}

export enum Config_MatchAuditLog_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_MatchAuditLog_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_MatchAuditLog_ApiInterface
    extends ConfigDataInterface<
        Config_MatchAuditLog_Modules_ApiEnum,
        Config_MatchAuditLog_ActionsMenu_ApiEnum,
        Config_MatchAuditLog_ActionsOther_ApiEnum,
        Config_Match_PageMenu_ApiEnum,
        Config_MatchAuditLog_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
